import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ChartColumnLine = ({chartData, title}) => {
	if (chartData == undefined || chartData.length == 0) {
		return
	}

	
	let cat = []
	let datas = []
	Object.entries(chartData).forEach(([key, value]) => {
		datas.push(value.data);
	});
	
	const optionsBar = {
		title: {
			text: title,
			style: {
				color: '#000',
				fontSize: "14px",
				fontWeight: "bold",
			}
		},
		xAxis: {
			categories: chartData[0].cat
		},
		yAxis: {
			title: {
				text: '상점 수'
			}
		},
		series: [{
			type: 'column',
			name: '2020',
			data: datas[2]
		}, {
			type: 'column',
			name: '2021',
			data: datas[3]
		}, {
			type: 'column',
			name: '2022',
			data: datas[4]
		}, {
			type: 'spline',
			name: '평균',
			data: datas[3],
			marker: {
				lineWidth: 2,
				lineColor: Hightcharts.getOptions().colors[3],
				fillColor: 'white'
			}
		}]
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} />
		</>
	);
};

export default ChartColumnLine;